import React from "react";
import classes from './UtilityModelDocumet.module.scss'
import Document from "../../../../components/Document";
export default function UtilityModelDocumet() {
    return(
        <Document/>

    )
    
}